import { render } from "./ComplianceSubmission.vue?vue&type=template&id=7b602542"
import script from "./ComplianceSubmission.vue?vue&type=script&lang=js"
export * from "./ComplianceSubmission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__